
define('modules/application/wizard/classes/accessoryLine',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"

  ],

  function(app, Backbone, genericElement) {

    var accessoryLine = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({
          template: "application/wizard/sections/accessoryLine/titleBar",
          tagName: "h3",

          serialize: function() {
            return {
              model: this.model,
              app: BticinoS4B.Instances.Models.ApplicationModel
            };
          },

          initialize: function() {

            window.BticinoS4B.eventAggregator.unbind("project:reset", this.removeValues);
            window.BticinoS4B.eventAggregator.bind("project:reset", this.removeValues, this);

            window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.setLabel);
            window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.setLabel, this);

            window.BticinoS4B.eventAggregator.bind("accessoryLine:confirmed", this.setLabel, this);

            this.model.get("stepEventAggregator").unbind("accessoryLine:removed", this.setLabel);
            this.model.get("stepEventAggregator").bind("accessoryLine:removed", this.setLabel, this);

            this.model.unbind("render:requested", this.setLabel);
            this.model.bind("render:requested", this.setLabel, this);

            this.model.titleBarView = this;

            this.setLabel();
          },

          setLabel: function() {
            if ((this.model.get("choosenLine")) && (this.model.get("choosenColor")))
              if ((this.model.get("choosenLine") !== "") && (this.model.get("choosenColor") !== "")) {
                this.$el.find(".titleBarcontent span").html($.i18n._(this.model.get("choosenLine").name) + " - " + $.i18n._(this.model.get("choosenColor").name));

                if (this.model.get("confirmed"))
                  this.$el.find(".titleBarcontent span").css("color", "#a0a2a3");

                this.$el.find(".titleBarcontent span").fadeIn(200);
              } else
                this.$el.find(".titleBarcontent span").fadeOut(200, function() {
                  $(this).hide();
                });
              else
                this.$el.find(".titleBarcontent span").fadeOut(200, function() {
                  $(this).hide();
                });
          },

          afterRender: function(){
            if(BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType()=="s4b"){
              this.$el.remove();
            }
          },

          onClose: function() {
            window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.setLabel);
            window.BticinoS4B.eventAggregator.unbind("accessoryLine:removed", this.setLabel);
          }
        }),

        content: genericElement.Views.content.extend({

          template: "application/wizard/sections/accessoryLine/content",
          className: "accessoryLine",
          events: {
            "change #line": "selectedLineChanged",
            "change #color": "selectedColorChanged",
            "click .toggleInfoButton": "toggleInfos"
          },

          serialize: function() {
            return genericElement.Views.content.prototype.serialize.apply(this);
          },

          initialize: function() {
            this.model.unbind("render:requested", this.render);
            this.model.bind("render:requested", this.render, this);
            this.model.bind("change:confirmed", this.render, this);

            window.BticinoS4B.eventAggregator.bind("kit:added", this.unbindAccessoryLineSelection, this);
            window.BticinoS4B.eventAggregator.bind("accessoryLine:confirmed", this.lockAccessoryLineSelection, this);

            if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
              this.selectedColorInitialize();

            // modifica s4b: accessoryline caricata nella system selection
            if(BticinoS4B.Instances.Models.QuoteTypesMenuModel && BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType()=="s4b")
              this.lockAccessoryLineSelection();
          },

          toggleInfos: function(e) {
            return genericElement.Views.content.prototype.toggleInfos(e, this);
          },

          lockAccessoryLineSelection: function() {
            this.$el.find("select#line").attr("disabled", "disabled");
            this.$el.find("select#line").removeAttr("rel");
            this.$el.find("span#selectline").remove();

            this.$el.find("select#color").attr("disabled", "disabled");
            this.$el.find("select#color").removeAttr("rel");
            this.$el.find("span#selectcolor").remove();

            this.model.set("confirmed", true);
          },

          unbindAccessoryLineSelection: function() {
            this.lockAccessoryLineSelection();
            window.BticinoS4B.eventAggregator.unbind("powerSupply:chosen", this.lockAccessoryLineSelection);
          },

          //Enable the color selector
          enableColorSelector: function() {
            this.$el.find("select#color").removeAttr("disabled");
            this.$el.find("span#selectcolor").removeClass("disabled");
          },

          //Disable the color selector
          disableColorSelector: function() {
            this.$el.find("select#color").attr("disabled", "disabled");
            this.$el.find("select#color").removeAttr("rel");

            this.$el.find("select#color option:first").attr("selected", "selected");
            this.$el.find("span#selectcolor").html($.i18n._("IDS_W5_9064") + "...");
            this.$el.find("span#selectcolor").remove();
            window.customizeFormElements.call();
          },

          //Event handler used when the line selector changes his value
          selectedLineChanged: function(event) {
            this.hideDetails();

            for (var i = 0; i < this.model.lines.length; i++) {
              if ($(event.target).val() !== "") {
                if (this.model.lines[i].id === $(event.target).val())
                  this.model.set("choosenLine", this.model.lines[i]);
              } else
                this.model.set("choosenLine", "");
            }

            this.populateColorDropDown($(event.target).val());
            window.BticinoS4B.Instances.Models.ApplicationModel.set('choosenLine',this.model.get('choosenLine'));
          },

          //Event handler used when the color selector changes his value
          selectedColorChanged: function(event) {
            if ($(event.target).val() === "") {
              this.model.set("choosenColor", null);
              this.hideDetails();
              this.trigger("accessoryLineRemoved");
            } else {
              for (var i = 0; i < this.model.get("choosenLine").colors.length; i++)
                if (this.model.get("choosenLine").colors[i].id === $(event.target).val())
                  this.model.set("choosenColor", this.model.get("choosenLine").colors[i]);

              this.model.set("accessoryLineId", this.model.get("choosenColor").accessoryLineId);
              this.setDetails($(event.target).val());
            }
            window.BticinoS4B.Instances.Models.ApplicationModel.set('accessoryLineId',this.model.get('accessoryLineId'));
            window.BticinoS4B.Instances.Models.ApplicationModel.set('choosenColor',this.model.get('choosenColor'));
          },

          selectedColorInitialize: function() {
            
            //modificato per matix che ha colore null!!!
            //choosenColor = window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor.id;
            // if (choosenColor === "") {
            //   this.model.set("choosenColor", null);
            //   this.hideDetails();
            //   this.trigger("accessoryLineRemoved");
            // } else {
            //   for (var i = 0; i < this.model.get("choosenLine").colors.length; i++)
            //     if (this.model.get("choosenLine").colors[i].id === choosenColor)
            //       this.model.set("choosenColor", this.model.get("choosenLine").colors[i]);

            //   this.model.set("accessoryLineId", this.model.get("choosenColor").accessoryLineId);
            //   this.setDetails(choosenColor);
            //   // window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen");
            // }
            if(window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor)
              choosenColor = window.BticinoS4B.Instances.Models.ApplicationModel.attributes.choosenColor.id;
            else
              choosenColor=null;
            if (choosenColor === "") {
              this.model.set("choosenColor", null);
              this.hideDetails();
              this.trigger("accessoryLineRemoved");
            } else {
              for (var i = 0; i < this.model.get("choosenLine").colors.length; i++)
                if (this.model.get("choosenLine").colors[i].id === choosenColor)
                  this.model.set("choosenColor", this.model.get("choosenLine").colors[i]);

              this.model.set("accessoryLineId", this.model.get("choosenColor").accessoryLineId);
              this.setDetails(choosenColor);
              // window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen");
            }
          },

          //Populate the color's dropdown with serie's colors
          populateColorDropDown: function(newLine) {
            this.$el.find("select#color option").remove();

            var newLineModel = _.filter(
              this.model.lines,
              function(line) {
                return line.id == newLine;
              }
            );

            if (newLineModel.length > 0) {
              for (var i = 0; i < newLineModel[0].colors.length; i++) {
                if (i === 0)
                  this.$el.find("select#color").append("<option selected='selected' value=\"" + newLineModel[0].colors[i].id + "\">" + $.i18n._(newLineModel[0].colors[i].name) + "</option>");
                else
                  this.$el.find("select#color").append("<option value=\"" + newLineModel[0].colors[i].id + "\">" + $.i18n._(newLineModel[0].colors[i].name) + "</option>");
              }
              this.$el.find("select#color").removeAttr("rel");
              this.$el.find("span#selectcolor").remove();

              this.enableColorSelector();
              this.model.set("choosenColor", newLineModel[0].colors[0]);
              this.model.set("accessoryLineId", newLineModel[0].colors[0].accessoryLineId);
              window.BticinoS4B.Instances.Models.ApplicationModel.set('accessoryLineId',this.model.get('accessoryLineId'));
              window.BticinoS4B.Instances.Models.ApplicationModel.set('choosenColor',this.model.get('choosenColor'));
              this.setDetails(newLineModel[0].colors[0].id);
              this.$el.find("select#color option:nth-child(2)").trigger("click");
            } else {
              this.$el.find("select#color").append('<option value="" selected="selected">' + $.i18n._("IDS_W5_9064") + '...</option>');
              this.disableColorSelector();
            }

            setTimeout(function() {
              window.customizeFormElements.call();
            }, 0);

          },

          //Retrieve and set the accessory line's details
          setDetails: function() {
            this.render();
          },

          showDetails: function(that) {
            if (that === undefined)
              that = this;

            that.$el.find(".exampleImage").fadeIn(200);
            that.$el.find(".description").fadeIn(200);
            that.$el.find(".linkContainer").fadeTo(200, 1);
          },

          hideDetails: function() {
            this.$el.find(".exampleImage").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".description").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".linkContainer").fadeTo(200, 0);
          },

          showLoader: function() {
            this.$el.find(".mini-loader").fadeIn(200);
          },

          hideLoader: function(callback) {
            var that = this;
            this.$el.find(".mini-loader").fadeOut(200, function() {
              $(this).hide();
              callback.call(that);
            });
          },

          afterRender: function() {
            if(BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType()=="s4b"){
              this.$el.remove();
            }
            setTimeout(function() {
              window.customizeFormElements.call();
            }, 0);
          },

          onClose: function() {
            this.model.unbind("change #line", this.selectedLineChanged);
            this.model.unbind("change #color", this.selectedColorChange);
          }
        })

      },

      Model: genericElement.Model.extend({

        defaults: {
          accessoryLineId: null,
          confirmed: false,
          lines: []
        },

        initialize: function() {

          this.unbind("change:choosenLine", this.lineChanged);
          this.bind("change:choosenLine", this.lineChanged, this);

          this.unbind("change:choosenColor", this.colorChanged);
          this.bind("change:choosenColor", this.colorChanged, this);

          this.unbind("change:accessoryLineId", this.accessoryLineIdChanged);
          this.bind("change:accessoryLineId", this.accessoryLineIdChanged, this);

          this.unbind("change:confirmed", this.confirmedChanged);
          this.bind("change:confirmed", this.confirmedChanged, this);

          window.BticinoS4B.eventAggregator.unbind("accessoryLine:confirmed", this.confirm);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:confirmed", this.confirm, this);

          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          this.retrieveAccessoryLines();
          

          // modifica s4b: accessoryline caricata nella system selection
          this.set("choosenLine", window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine"));
          this.set("choosenColor", window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor"));
          this.trigger("change:choosenColor");
          this.set("accessoryLineId", window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          this.trigger("change:accessoryLineId");
        },

        retrieveAccessoryLineDetails: function(id) {
          var details;
          _.each(this.lines, function(line) {
            var color = _.filter(line.colors, function(color) {
              return color.accessoryLineId === id;
            });

            if (color.length > 0)
              details = color[0];
          });
          return details;
        },

        retrieveExampleProduct: function(id) {
          products = [{
            id: "0"
          }, {
            id: "33",
            image: "/assets/img/33.jpg"
          }, {
            id: "31",
            image: "/assets/img/31.jpg"
          }, {
            id: "32",
            image: "/assets/img/32.jpg"
          }, {
            id: "4",
            image: "/assets/img/4.jpg"
          }, {
            id: "5",
            image: "/assets/img/5.jpg"
          }, {
            id: "21",
            image: "/assets/img/21.jpg"
          }, {
            id: "8",
            image: "/assets/img/8.jpg"
          }, {
            id: "13",
            image: "/assets/img/13.jpg"
          }, {
            id: "14",
            image: "/assets/img/14.jpg"
          }];

          products = _.filter(products, function(product) {
            return product.id == id;
          });

          if (products.length == 1)
            return products[0];
        },

        confirm: function() {
          this.set("confirmed", true);
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.accessoryLine = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.accessoryLine = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.accessoryLine = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.accessoryLine = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.accessoryLine = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.accessoryLine = this;
              break;
          }
          if(!BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"))
              BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLines", this);
        },

        accessoryLineIdChanged: function() {
          if ((this.get("accessoryLineId")) && (this.get("accessoryLineId") !== "")) {
            //this.attributes.stepEventAggregator.trigger("accessoryLine:chosen", this.get("accessoryLineId"));
            window.BticinoS4B.eventAggregator.trigger("accessoryLine:chosen-reserved", this.get("accessoryLineId"));
          } else {
            //this.attributes.stepEventAggregator.trigger("accessoryLine:removed");
            window.BticinoS4B.eventAggregator.trigger("accessoryLine:removed-reserved");
          }

        },

        retrieveAccessoryLines: function() {
          var that = this;
          $.ajax({
            type: "POST",
            datatype: "json",
            contentType: "application/json",
            url: "/WizardService.svc/getAccessoryLines",
            async: false,
            data: JSON.stringify({
              token: window.BticinoS4B.token
            }),
            success: function(data) {
              that.lines = _.filter(data.lines, function(line) {
                return line.name != "ND";
              });
            }
          });
        },

        lineChanged: function() {
          if (this.get("choosenLine") === "") {
            this.set("choosenColor", "");
            this.set("accessoryLineId", "");
          }
        },

        colorChanged: function() {
          var choosenColor = this.get("choosenColor");
          var lineName = "";
          var colorName = "";
          var choosenLine = this.get("choosenLine");
          var accessoryLineId;

          if (choosenLine)
            lineName = choosenLine.name;

          if (choosenColor !== null) {
            //var choosenColor= _.filter(choosenLine.colors,function(color){ return color.id==colorId;})[0];

            if (choosenColor !== undefined) {
              colorName = choosenColor.name;
              accessoryLineId = choosenColor.accessoryLineId;
              this.set("accessoryLineId", accessoryLineId);
              //this.set("choosenColor",choosenColor);
            } else {
              colorName = "";
              accessoryLineId = undefined;
            }
          } else
            this.set("accessoryLineId", "");
        },

        confirmedChanged: function() {
          this.trigger("render:requested");
        },

        loadProject: function(model) {
          var accessoryLineModel = model.accessoryLine;
          var choosenLine = null;
          var choosenColor = null;

            if (accessoryLineModel.line)
              choosenLine = _.filter(this.lines, function(line) {
                return line.id == accessoryLineModel.line;
              })[0];
            if (accessoryLineModel.color)
              choosenColor = _.filter(choosenLine.colors, function(color) {
                return color.id == accessoryLineModel.color;
              })[0];

            this.set("choosenLine", choosenLine);
            this.set("choosenColor", choosenColor);

            this.trigger("render:requested");

        }

      })
    });

    // Required, return the module for AMD compliance
    return accessoryLine;
  });